<template>
  <div>
    <b-row style="margin-top: 25px" align-v="stretch">
      <b-col align-self="start" lg="6">
        <vs-card>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="auto" class="pr-0">
              <b-button
                class="bg-dark"
                style="border-color: white"
                v-on:click="isManualScan(true)"
              >
                {{ $t("ManualOperation") }}</b-button
              >
            </b-col>
            <b-col cols="12" md="auto">
              <b-button
                class="bg-dark"
                style="border-color: white"
                v-on:click="isManualScan(false)"
              >
                {{ $t("ScanOperation") }}</b-button
              >
            </b-col>
          </b-row>
        </vs-card>
        <vs-card>
          <b-row v-if="manualOperation == true">
            <b-col v-if="isMobile()">
              <b-row class="mt-2">
                <p class="mb-0">{{ $t("Shelf") }}</p>

                <v-select
                  color="danger"
                  v-model="shelf"
                  :options="shelf_choices"
                  size="small"
                  label="name"
                  @input="
                    getShelfForList();
                    getShelf(true);
                  "
                  :disabled="stockOnShelf.length > 0"
                  autocomplete
                  ref="selectElement"
                  name="shelf"
                  v-validate="'required'"
                  :taggable="true"
                >
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('shelf')">{{
                  errors.first("shelf")
                }}</span>
              </b-row>

              <div>
                <input
                  id="productCodeManuel"
                  ref="productCodeManuel"
                  v-model="productCode"
                  @keyup.enter="productControl(true)"
                  @input="stockNoValidate"
                  autocomplete="off"
                  @focus="handleFocus(4)"
                  style="
                    padding: 0px;
                    margin: 0px;
                    width: 50px;
                    position: absolute;
                    opacity: 0;
                    width: -webkit-fill-available;
                    height: 250px;
                  "
                />
                <b-row style="text-align: center; margin: 50px">
                  <b-col>
                    <Icon
                      icon="bi:upc-scan"
                      style="margin-right: 5px"
                      width="150"
                      height="150"
                    />
                  </b-col>
                  <h4 style="text-align: center" class="mt-10">
                    {{ $t("PleaseSerial") }}
                  </h4>
                </b-row>
              </div>

              <div class="items-center pl-6 mt-5 mb-0">
                <b-row align-h="end">
               <!--   <b-col cols="6" md="auto">
                    <b-button
                      class="bg-primary"
                      style="border-color: white; width: 100%"
                      v-on:click="isSidebarActiveAddWithExcel = true"
                    >
                      <Icon icon="icon-park-outline:excel" width="20" height="20" />
                      {{ $t("AddWithExcel") }}</b-button
                    >
                  </b-col>
                  <b-col cols="6" md="auto">
                    <b-button
                      class="bg-primary"
                      style="border-color: white"
                      v-on:click="productControl()"
                    >
                      <Icon
                        icon="material-symbols:save-outline"
                        style="margin-right: 5px"
                        width="20"
                        height="20"
                      />{{ $t("Add") }}
                    </b-button>
                  </b-col>-->
                </b-row>
              </div>
            </b-col>
            <b-col v-else>
              <b-row class="mt-2">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('ShelfCode')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <v-select
                    color="danger"
                    v-model="shelf"
                    :options="shelf_choices"
                    size="small"
                    label="name"
                    @input="
                      getShelfForList();
                      getShelf(true);
                    "
                    :disabled="stockOnShelf.length > 0"
                    autocomplete
                    ref="selectElement"
                    name="shelf"
                    v-validate="'required'"
                  >
                  </v-select>
                  <span class="text-danger text-sm" v-show="errors.has('shelf')">{{
                    errors.first("shelf")
                  }}</span>
                </b-col>
              </b-row>

              <div>
                <input
                  id="productCodeManuel"
                  ref="productCodeManuel"
                  v-model="productCode"
                  @keyup.enter="productControl(true)"
                  @input="stockNoValidate"
                  autocomplete="off"
                  @focus="handleFocus(4)"
                  style="
                    padding: 0px;
                    margin: 0px;
                    width: 50px;
                    position: absolute;
                    opacity: 0;
                    width: -webkit-fill-available;
                    height: 250px;
                  "
                />
                <b-row style="text-align: center; margin: 50px">
                  <b-col>
                    <Icon
                      icon="bi:upc-scan"
                      style="margin-right: 5px"
                      width="150"
                      height="150"
                    />
                  </b-col>
                  <h4 style="text-align: center" class="mt-10">
                    {{ $t("PleaseSerial") }}
                  </h4>
                </b-row>
              </div>
              <div class="items-center pl-6 mt-5 mb-0">
                <b-row align-h="end">
                <!--  <b-col cols="3" md="auto">
                    <b-button
                      class="bg-primary"
                      style="border-color: white; width: 100%"
                      v-on:click="isSidebarActiveAddWithExcel = true"
                    >
                      <Icon icon="icon-park-outline:excel" width="20" height="20" />
                      {{ $t("AddWithExcel") }}</b-button
                    >
                  </b-col>-->
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <div v-if="isMobile()">
              <div style="height: 95%" v-if="scanText == 'PleaseShelf'">
                <input
                  id="shelfCode"
                  ref="shelfCode"
                  v-model="shelfCode"
                  @keyup.enter="getShelf(false)"
                  @focus="handleFocus(1)"
                  @input="stockNoValidate"
                  autocomplete="off"
                  style="
                    padding: 0px;
                    margin: 0px;
                    width: 50px;
                    position: absolute;
                    opacity: 0;
                    width: 300px;
                    height: 250px;
                  "
                />
                <b-row style="text-align: center; margin: 50px">
                  <b-col>
                    <Icon
                      icon="bi:upc-scan"
                      style="margin-right: 5px"
                      width="150"
                      height="150"
                    />
                  </b-col>
                  <h4 style="text-align: center" class="mt-10">
                    {{ $t(scanText) }}
                  </h4>
                </b-row>
              </div>
              <div style="height: 95%" v-else-if="scanText == 'PleaseSerial'">
                <input
                  id="productCode"
                  ref="productCode"
                  v-model="productCode"
                  @keyup.enter="productControl(true)"
                  @input="stockNoValidate"
                  autocomplete="off"
                  @focus="handleFocus(3)"
                  style="
                    padding: 0px;
                    margin: 0px;
                    width: 50px;
                    position: absolute;
                    opacity: 0;
                    width: 300px;
                    height: 250px;
                  "
                />
                <b-row style="text-align: center; margin: 50px">
                  <b-col>
                    <Icon
                      icon="bi:upc-scan"
                      style="margin-right: 5px"
                      width="150"
                      height="150"
                    />
                  </b-col>
                  <h4 style="text-align: center" class="mt-10">
                    {{ $t(scanText) }}
                  </h4>
                </b-row>
              </div>
            </div>
            <div v-else>
              <div style="height: 95%" v-if="scanText == 'PleaseShelf'">
                <input
                  id="shelfCode"
                  ref="shelfCode"
                  v-model="shelfCode"
                  @keyup.enter="getShelf(false)"
                  @focus="handleFocus(1)"
                  @input="stockNoValidate"
                  autocomplete="off"
                  style="
                    padding: 0px;
                    margin: 0px;
                    width: 50px;
                    position: absolute;
                    opacity: 0;
                    width: 500px;
                    height: 450px;
                  "
                />
                <b-row style="text-align: center; margin: 50px">
                  <b-col>
                    <Icon
                      icon="bi:upc-scan"
                      style="margin-right: 5px"
                      width="150"
                      height="150"
                    />
                  </b-col>
                  <h4 style="text-align: center" class="mt-10">
                    {{ $t(scanText) }}
                  </h4>
                </b-row>
              </div>
              <div style="height: 95%" v-else-if="scanText == 'PleaseSerial'">
                <input
                  id="productCode"
                  ref="productCode"
                  v-model="productCode"
                  @keyup.enter="productControl(true)"
                  @input="stockNoValidate"
                  autocomplete="off"
                  @focus="handleFocus(3)"
                  style="
                    padding: 0px;
                    margin: 0px;
                    width: 50px;
                    position: absolute;
                    opacity: 0;
                    width: 500px;
                    height: 450px;
                  "
                />
                <b-row style="text-align: center; margin: 50px">
                  <b-col>
                    <Icon
                      icon="bi:upc-scan"
                      style="margin-right: 5px"
                      width="150"
                      height="150"
                    />
                  </b-col>
                  <h4 style="text-align: center" class="mt-10">
                    {{ $t(scanText) }}
                  </h4>
                </b-row>
              </div>
            </div>
          </b-row>
        </vs-card>
      </b-col>
      <b-col>
        <vs-card>
          <b-row class="justify-content-md-center" v-if="isMobile()">
            <b-col cols="12" md="auto" class="mb-2">
              <b-button
                class="bg-danger"
                style="border-color: white; width: 100%"
                v-on:click="isSidebarActiveProcesscancelShelfList = true"
              >
                <Icon
                  icon="material-symbols:cancel-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Cancel") }}
              </b-button>
            </b-col>
            <b-col cols="12" md="auto" v-if="shelfData != ''">
              <b-button
                class="bg-dark"
                style="border-color: white; width: 100%"
                v-on:click="shelfStockList(true)"
              >
                {{ $t("shelfStockList") }}</b-button
              >
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center" v-else>
            <b-col cols="12" md="auto" v-if="shelfData != ''">
              <b-button
                class="bg-dark"
                style="border-color: white"
                v-on:click="shelfStockList(true)"
              >
                {{ $t("shelfStockList") }}</b-button
              >
            </b-col>
            <b-col cols="3" md="auto">
              <b-button
                class="bg-danger"
                style="border-color: white"
                v-on:click="isSidebarActiveProcesscancelShelfList = true"
              >
                <Icon
                  icon="material-symbols:cancel-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </vs-card>

        <vs-card>
          <b-col cols="12" md="auto" class="mb-5">
            <b-button class="bg-dark" style="border-color: white" v-if="CorridorCode">
              <span v-if="CorridorCode">
                {{ $t("CorridorCode") }}: {{ CorridorCode }} -
              </span>
              <span v-if="shelfCode">
                {{ $t("shelfCode") }}:{{ shelfCode }}
              </span></b-button
            >
          </b-col>
        </vs-card>
      </b-col>
    </b-row>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="saveData()"
      :active.sync="isSidebarActiveSerialBarcode"
      color="primary"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row class="mt-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="$t('Barcode')"
                label-for="h-first-name"
                style="font-weight: 600"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="serialBarcode"
                :options="serial_barcodes"
                size="small"
                label="name"
                autocomplete
                ref="selectElement"
                name="serialBarcode"
                v-validate="'required'"
              >
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('serialBarcode')">{{
                errors.first("serialBarcode")
              }}</span>
            </b-col>
          </b-row>

          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="saveData()"
      @cancel="clearSerial"
      @close="clearSerial"
      :active.sync="isSidebarActiveCompleteProcess"
      color="primary"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row class="mt-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="$t('CorridorCode')"
                label-for="h-first-name"
                style="font-weight: 600"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              {{ CorridorCode }}
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="$t('ShelfCode')"
                label-for="h-first-name"
                style="font-weight: 600"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              {{ shelfCode }}
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="$t('SerialNumber')"
                label-for="h-first-name"
                style="font-weight: 600"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              {{ mainBarcode }}
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="$t('Quantity')"
                label-for="h-first-name"
                style="font-weight: 600"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8"> 1 </b-col>
          </b-row>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="deleteQuantity"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="cancelShelfList"
      :active.sync="isSidebarActiveProcesscancelShelfList"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-popup
      class="holamundo"
      :title="$t('AddWithExcel')"
      :active.sync="isSidebarActiveAddWithExcel"
      @close="closeExcelAddPopup"
      @cancel="closeExcelAddPopup"
      fullscreen
    >
      <vs-prompt
        :title="$t('Submit')"
        :acceptText="$t('Save')"
        :cancelText="$t('Cancel')"
        @accept="addProductWithExcel"
        :active.sync="activePromptToProduct"
      >
        <div class="con-exemple-prompt">
          <b-row style="align-items: center">
            <b-col lg="12">
              <span
                >{{ $t("ConfirmToUpdateList") }} {{ $t("AreYSure") }}
                {{ $t("CantUndo") }}</span
              >
            </b-col>
          </b-row>
        </div>
      </vs-prompt>
      <b-row>
        <b-col lg="6">
          <vs-card>
            <b-row class="mb-8 mt-8">
              <UploadBtnDynamic :isUploaded="isUploadedAddExcel" />
            </b-row>
            <b-row class="justify-content-md-end">
              <b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="clearAddExcel()"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="downloadSampleAddExcel()"
                >
                  {{ $t("SampleExcel") }}</b-button
                >
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="activePromptToProduct = true"
                >
                  {{ $t("Add") }}
                </b-button></b-col
              >
            </b-row>
          </vs-card>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <vs-card>
                <ag-grid-vue
                  style="width: 100%; height: 400px"
                  class="ag-theme-alpine"
                  :suppressRowClickSelection="true"
                  :defaultColDef="defaultColDef"
                  :columnDefs="excelListColumnAdd"
                  :rowData="wholeAcceptedProductListAddExcel"
                  :localeText="localeText"
                  @grid-ready="onGridReady"
                >
                </ag-grid-vue>
              </vs-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vs-popup>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="confirmLeave(true)"
      @cancel="confirmLeave(false)"
      :active.sync="isSidebarActiveconfirmLeave"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <b-row style="margin-top: 15px">
          <b-col cols="12" align-self="center">
            <h6>{{ $t("LeavePageInfo") }}</h6>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <ProductListToShelf
      :isSidebarActive="isSidebarActiveShelfProductList"
      :ShelfCode="shelfCode"
      @closeSidebar="toggleShelfProductListSidebar"
    />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
import updateDeleBtnDynamic from "../CellRenderers/updateDeleteBtnDynamic.vue";
import ProductListToShelf from "./ProductListToShelf";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import UploadBtnDynamic from "../components/global-components/UploadBtnDynamic.vue";
import userJson from "../../../public/user.json";
import { isMobile } from "mobile-device-detect";

export default {
  components: {
    UploadBtnDynamic,
    ProductListToShelf,
    uuid,
    Icon,
    vSelect,
    AgGridVue,
    updateDeleBtnDynamic,
    VuePerfectScrollbar,
  },
  props: {
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      focusEnabled: true,
      serialBarcode: "",
      mainBarcode: "",
      isSidebarActiveCompleteProcess: false,
      isMobile: function () {
        return isMobile;
      },
      isSidebarActiveSerialBarcode: false,
      isSidebarActiveconfirmLeave: false, // Prompt aktiflik durumu
      nextRouteCallback: null, // Rotaya devam etme callback fonksiyonu
      activePromptToProduct: false,
      wholeAcceptedProductListAddExcel: [],
      isSidebarActiveAddWithExcel: false,
      selectedBarcodeMatch: "",
      currentFocusedInput: null,
      firstInputFocused: false,
      deleteBarcode: "",
      isSidebarActiveProcesscancelShelfList: false,
      isSidebarActiveProcess: false,
      selected: "",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      shelfData: [],
      isSidebarActiveShelfProductList: false,
      allProductList: [],
      productCode: "",
      stock: "",
      barcode: "",
      customer: "",
      corridor: "",
      shelfCode: "",
      CorridorCode: "",
      CorridorId: "",
      CorridorName: "",
      ShelfId: "",
      ShelfName: "",
      CompanyId: "",
      CompanyName: "",
      CompanyCode: "",
      barcodeCh: "",
      quantity: 1,

      barcodematch_options: [],
      corridor_choices: [],
      stock_choices: [],
      barcode_choices: [],
      barcodeCh_choices: [],
      shelf_choices: [],
      customer_choices: [],
      manualOperation: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      excelListColumnAdd: [],
      serial_barcodes: [],
      shelf: [],
      shelfColumns: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      scanText: "PleaseShelf",
      isUploadedAddExcel: false,
    };
  },
  methods: {
    clearSerial() {
      console.log("inn");
      this.productCode = "";
      this.mainBarcode = "";
      this.serialBarcode = "";
      this.serial_barcodes = "";
    },
    handleBeforeUnload(event) {
      if (this.allProductList.length > 0) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    confirmLeave(isConfirmed) {
      if (isConfirmed) {
        this.nextRouteCallback && this.nextRouteCallback(); // Geçişe izin ver
      } else {
        this.nextRouteCallback && this.nextRouteCallback(false); // Geçişi engelle
      }
      this.isSidebarActiveconfirmLeave = false; // Promptu kapat
    },
    downloadSampleAddExcel() {
      const link = document.createElement("a");
      link.href = userJson.assetsUrl + "AddSerialToShelfTemplate.xlsx";
      link.download = "AddSerialToShelfTemplate.xlsx";
      link.click();
    },
    setItem() {
      this.excelListColumnAdd = [];
      let columnList = Object.keys(this.wholeAcceptedProductListAddExcel[0]);
      columnList.forEach((value, index) => {
        this.excelListColumnAdd.push({
          headerName: this.$t(value),
          field: value,
          filter: "agSetColumnFilter",
        });
      });
    },
    addProductWithExcel() {
      this.allProductList = this.wholeAcceptedProductListAddExcel;
      this.wholeAcceptedProductListAddExcel.forEach((val, index) => {
        var createdId = uuid.v4();
        this.wholeAcceptedProductListAddExcel[index].shelfTransId = createdId;
        this.wholeAcceptedProductListAddExcel[index].shelfTransStatus = true;
      });

      if (this.wholeAcceptedProductListAddExcel.length > 0) {
        this.saveData(this.wholeAcceptedProductListAddExcel.length - 1);
      }
    },
 
    clearAddExcel() {
      this.wholeAcceptedProductListAddExcel = [];
      this.isUploadedAddExcel = false;
    },
    closeExcelAddPopup() {
      this.isSidebarActiveAddWithExcel = false;
      this.isUploadedAddExcel = false;
      this.wholeAcceptedProductListAddExcel = [];
    },
    stockNoValidate() {
      this.CorridorCode = this.CorridorCode.replace(/\?/g, "_");
      this.shelfCode = this.shelfCode.replace(/\?/g, "_");
      this.productCode = this.productCode.replace(/\?/g, "_").replace(/ı/g, "i");
    },
    keepFocus() {
      if (!this.focusEnabled) return;
      this.$nextTick(() => {
        if (this.manualOperation != true)
          if (this.currentFocusedInput === 1) {
            this.$refs.shelfCode.focus();
          } else if (this.currentFocusedInput === 3) {
            this.$refs.productCode.focus();
          } else if (this.currentFocusedInput === 4) {
            this.$refs.productCodeManuel.focus();
          }
      });
    },
    handleFocus(inputNumber) {
      if (inputNumber === 1 && !this.firstInputFocused) {
        this.currentFocusedInput = 1;
        this.firstInputFocused = true;
      } else if (inputNumber === this.currentFocusedInput) {
        return;
      } else if (inputNumber !== 1) {
        this.currentFocusedInput = inputNumber;
      }
      this.keepFocus();
    },
    getShelfForList() {
      this.shelfData = { ShelfCode: this.shelf.code };
    },
    deleteQuantity() {
      //     this.allProductList.splice(this.deleteBarcode, 1);
      this.isSidebarActiveProcess = false;
      //    this.deleteBarcode = -1;
    },
    reduceQuantity(item, index) {
      let obj = {
        barcode: item.barcode,
        quantity: -1,
      };
    },
    handleSelected(tr) {},
    toggleShelfProductListSidebar(val = false) {
      this.isSidebarActiveShelfProductList = val;
    },

    cancelShelfList() {
      this.closeShelfPopup();
      this.setItems();
      this.isSidebarActiveProcesscancelShelfList = false;
      this.scanText = "PleaseShelf";
      setTimeout(() => {
        document.getElementById("shelfCode").focus();
      }, 50);
    },
    shelfStockList() {
      this.toggleShelfProductListSidebar(true);
    },
    saveAllList() {
      if (this.allProductList.length > 0) {
        this.isSidebarActiveCompleteProcess = true;
        //   this.saveData(this.allProductList.length - 1);
      }
    },
    saveData() {
      const vs = this.$vs;
      var createdId = uuid.v4();
      let obj = {
        shelfTransId: createdId,
        barcode: this.serialBarcode != "" ? this.serialBarcode : "",
        quantity: 1,
        shelfTransStatus: true,
        serial: this.mainBarcode,
        totalCount: 0,
        stockName: "",
        corridorCode: this.CorridorCode,
        shelfCode: this.shelfCode,
        companyCode: this.companyCode,
      };
      this.$store
        .dispatch("storehouse/addShelfTrans", obj)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            console.log(response);
            try {
              this.mainBarcode = "";
              this.productCode = "";
              this.selectedBarcodeMatch = "";
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else if (response.status == 400) {
            console.log(response.data.message);
            if (
              response.data.message.includes(
                "There is no record of the barcode or serial number"
              )
            ) {
              this.focusEnabled = false;
              this.isSidebarActiveSerialBarcode = true;
              this.serial_barcodes = JSON.parse(response.data.json);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    setItems() {
      /*    this.allProductList = this.stockOnShelf;
      //   this.CorridorName = this.allProductList[0].corridorName;
      this.CorridorCode = this.allProductList[0].corridorCode;
      this.CorridorId = this.allProductList[0].corridorId;
      this.ShelfName = this.allProductList[0].shelfName;
      this.shelfCode = this.allProductList[0].shelfCode;
      this.ShelfId = this.allProductList[0].shelfId;
      this.CompanyName = this.allProductList[0].companyName;
      this.CompanyCode = this.allProductList[0].companyCode;
      this.CompanyId = this.allProductList[0].companyId;*/
      this.scanText = "PleaseSerial";
      setTimeout(() => {
        document.getElementById("productCode").focus();
      }, 50);
    },
    getBarcodes() {
      this.barcode_choices = [];
      if (this.CompanyId != "")
        this.$store
          .dispatch("stock/listStockBarcodesForStock", this.stock.value)
          .then((response) => {
            if (response.success == true) {
              JSON.parse(response.json).forEach((val, index) => {
                this.barcode_choices.push({
                  value: val.StockBarcodeId,
                  code: val.Barcode,
                  name: val.Barcode,
                });
              });
              try {
              } catch (error) {
                console.log(error);
              }
            } else console.log(response.data);
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
    },
    getCustomerStockList() {
      this.stock_choices = [];
      if (this.CompanyId != "")
        this.$store
          .dispatch("stock/listStockForCompany", this.CompanyId)
          .then((response) => {
            if (response.success == true) {
              this.stock_choices = [];
              JSON.parse(response.json).forEach((val, index) => {
                this.stock_choices.push({
                  value: val.StockId,
                  code: val.Stockno,
                  name: val.StockName,
                  id: val.StockId + "-" + index,
                });
              });
              try {
              } catch (error) {
                console.log(error);
              }
            } else
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
    },
    isManualScan(val) {
      this.manualOperation = val;
      this.shelf_choices = [];
      /*   this.allProductList = [];
      this.closeShelfPopup();*/
      if (val == true) {
        if (this.stockOnShelf.length > 0) {
          this.setItems();

          this.shelf = {
            value: this.ShelfId,
            name: this.ShelfName,
            code: this.shelfCode,
          };

          this.stock_choices = [];
          this.getCustomerStockList();
        } else {
          this.getShelfList();
          this.customerListOption = [];
          this.customer_choices = [];
          this.customerListOption = this.companydata;
          this.customerListOption.forEach((val, index) => {
            this.customer_choices.push({
              value: val.CompanyId,
              name: val.CompanyName,
              code: val.CompanyNo,
            });
          });
        }
      } else {
        setTimeout(() => {
          document.getElementById("shelfCode").focus();
        }, 50);
      }
    },
    getShelfList() {
      this.shelf_choices = [];
      this.$store.dispatch("storehouse/listShelf").then((response) => {
        if (response.success == true) {
          if (JSON.parse(response.json)) {
            JSON.parse(response.json).forEach((val, index) => {
              this.shelf_choices.push({
                value: val.ShelfId,
                code: val.ShelfCode,
                name: val.ShelfName,
              });
            });
          }
        } else console.log(response.statusText);
      });
    },
    productControl(isScan) {
      let barcode = this.barcode.code;
      if (isScan == true) barcode = this.productCode;
      else if (this.selectedBarcodeMatch != "") barcode = this.selectedBarcodeMatch;
      this.mainBarcode = barcode;
      this.isSidebarActiveCompleteProcess = true;
    },

    // check shelf when input enter
    getShelf(isSelect) {
      if (!isSelect) this.$refs.shelfCode.blur();
      const vs = this.$vs;
      this.ShelfId = "";
      this.ShelfName = "";
      this.CorridorId = "";
      this.CorridorName = "";
      this.CompanyId = "";
      this.CompanyCode = "";
      this.CompanyName = "";
      try {
        this.$store
          .dispatch(
            "storehouse/listShelfTransShelfCheck",
            isSelect ? this.shelf.code : this.shelfCode
          )
          .then((response) => {
            try {
              if (response.success == true) {
                this.ShelfId = JSON.parse(response.json).ShelfId;
                this.shelfData = JSON.parse(response.json);
                this.ShelfName = JSON.parse(response.json).ShelfName;
                this.shelfCode = JSON.parse(response.json).ShelfCode;
                this.CorridorId = JSON.parse(response.json).CorrigorId;
                this.CorridorCode = JSON.parse(response.json).CorridorCode;
                this.CorridorName = JSON.parse(response.json).CorridorName;
                this.CompanyId = JSON.parse(response.json).CompanyId;
                this.CompanyCode = JSON.parse(response.json).CompanyNo;
                this.CompanyName = JSON.parse(response.json).CompanyName;
                if (isSelect) this.getCustomerStockList();

                this.scanText = "PleaseSerial";
                setTimeout(() => {
                  document.getElementById("productCode").focus();
                }, 50);
                this.currentFocusedInput = 3;
                vs.notify({
                  text: response.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              } else {
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                this.shelfCode = "";
                setTimeout(() => {
                  document.getElementById("shelfCode").focus();
                }, 50);
              }
            } catch (error) {
              this.shelfCode = "";
              setTimeout(() => {
                document.getElementById("shelfCode").focus();
              }, 50);
              vs.notify({
                text: error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    // check corridor when input enter
    getBarcodeMatchingList() {
      const vs = this.$vs;
      this.barcode_options = [];
      this.$store
        .dispatch("stock/listStockMatching")
        .then((response) => {
          if (response.success == true) {
            try {
              let stockJson = JSON.parse(response.json);

              this.barcodematch_options = stockJson;
            } catch (error) {
              console.log(response);
            }
          } else console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    closeShelfPopup() {
      this.shelf = "";
      this.stock = "";
      this.barcode = "";
      this.customer = "";
      this.corridor = "";
      this.shelfCode = "";
      this.productCode = "";
      this.scanText = "PleaseShelf";
      this.CorridorId = "";
      this.CorridorName = "";
      this.CorridorCode = "";
      this.ShelfId = "";
      this.ShelfName = "";
      this.CompanyId = "";
      this.CompanyName = "";
      this.CompanyCode = "";
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },
  mounted() {
    this.getBarcodeMatchingList();
    window.addEventListener("click", this.keepFocus);
    this.$root.$on("excelData", (paramDetail) => {
      if (paramDetail) this.isUploaded = true;
      this.wholeAcceptedProductListAddExcel = paramDetail;
      this.setItem();
    });
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.keepFocus);
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    this.$root.$off("excelData");
  },
  created() {
    this.currentFocusedInput = 1;
    this.handleFocus(1);
    setTimeout(() => {
      document.getElementById("shelfCode").focus();
    }, 1000);
    if (this.stockOnShelf.length > 0) {
      this.setItems();
    }
    const dict = {
      custom: {
        corridor: {
          required: this.$t("customerNameRequired"),
          alpha: this.$t("customerNameRequired"),
        },
        shelf: {
          required: this.$t("shelfRequired"),
          alpha: this.$t("shelfRequired"),
        },
        customer: {
          required: this.$t("customerRequired"),
          alpha: this.$t("customerRequired"),
        },

        stock: {
          required: this.$t("stockRequired"),
          alpha: this.$t("stockRequired"),
        },
        quantity: {
          required: this.$t("quantityRequired"),
          alpha: this.$t("quantityRequired"),
        },
      },
    };
    Validator.localize("en", dict);
  },
  beforeRouteLeave(to, from, next) {
    /* if (this.allProductList.length > 0) {
      // Barcode varsa promptu göster
      this.isSidebarActiveconfirmLeave = true;
      this.nextRouteCallback = next; // Callback fonksiyonunu sakla
    } else {
      next(); // Değişiklik yoksa geçişe izin ver
    }*/
  },
  watch: {
    stockOnShelf(val) {
      if (val.length > 0) {
        this.setItems();
      }
      return val;
    },
    companydata(val) {
      return val;
    },
    data(val) {
      return val;
    },
  },
  computed: {
    stockOnShelf: {
      get() {
        return this.$store.state.storehouse.StockOnShelf;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
};
</script>
<style lang="scss">
.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 80px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.con-vs-dialog {
  z-index: 520055;
}

.vs-table--tbody-table {
  min-width: auto;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  min-width: auto;
}
</style>
